import { z } from 'zod'

/*
 * O Zod 4 testa `new Function('')` na primeira validação de objeto para ligar o caminho rápido
 * (JIT). Com a CSP de produção (sem 'unsafe-eval'), o navegador barra o teste e registra uma
 * violação de `script-src` a cada carga da página, mesmo com o erro engolido pelo Zod. `jitless`
 * pula o teste (achado no ensaio da Sprint 15 com o Chromium). O main.tsx importa este módulo antes
 * de qualquer outro que valide dados.
 */
z.config({ jitless: true })
